import LogoApp from '../../../components/logoapp';

const CardFinish = ({ activity, name, score, questionDetails }) => {
  return (
    <div className="flex flex-col items-center justify-center w-full bg-gray-100 p-4 rounded-md">
      <LogoApp />
      <h1 className="text-xl font-bold ">{name}</h1>
      <h1 className="text-2xl font-bold  ">CONGRATULATIONS!</h1>
      <h1 className="text-lg ">You have Completed</h1>
      <h1 className="text-lg font-bold ">
        {activity.activity_name}
      </h1>
      <table className="table-auto w-full bg-white rounded-lg shadow-lg mt-5">
        <thead>
          <tr className="bg-black text-white">
            <th className="border px-4 py-2 text-center">#</th>
            <th className="border px-4 py-2 text-left">ANSWER</th>
            <th className="border px-4 py-2 text-center uppercase">Score</th>
          </tr>
        </thead>
        <tbody>
          {questionDetails?.map((detail, index) => (
            <tr
              key={index}
              className={`font-bold ${
                index % 2 === 0 ? 'bg-[#0e4b66]' : 'bg-[#156082]'
              }  text-white`}>
              <td className="border px-4 py-2 text-center">{index + 1}</td>
              <td className="border px-4 py-2 text-left">{detail.status}</td>
              <td className="border px-4 py-2 text-center">{detail.points}</td>
            </tr>
          ))}
          <tr className="bg-black text-white font-bold">
            <td className="border px-4 py-2 text-center" colSpan="2">
              YOUR SCORE
            </td>
            <td className="border px-4 py-2 text-center">{score}</td>
          </tr>

          <tr className="bg-black text-white font-bold">
            <td className="border px-4 py-2 text-center" colSpan="2">
             TIME TAKEN
            </td>
            <td className="border px-4 py-2 text-center">{questionDetails.reduce((total, item) => total + item.timer, 0)} sec</td>
          </tr>


        </tbody>
      </table>

      {/* <div className="w-full flex justify-center items-center mt-5">
        <a
          href="/leaderboard-round1"
          className="w-full font-bold cursor-pointer flex justify-center items-center text-lg text-white py-2 px-2 border-b-4 border-[#0e4b66] bg-[#156082]  rounded-lg "
        >
          VIEW ROUND 1 LEADERBOARD
        </a>
      </div>

      <div className="w-full flex justify-center items-center mt-2">
        <a
          href="/leaderboard-round2"
          className="w-full font-bold cursor-pointer flex justify-center items-center text-lg text-white py-2 px-2 border-b-4 border-[#0e4b66] bg-[#156082]  rounded-lg "
        >
          VIEW ROUND 2 LEADERBOARD
        </a>
      </div> */}

      {/* <div className="w-full flex justify-center items-center mt-5">
        <a
          href="/leaderboard"
          className="w-full font-bold cursor-pointer flex justify-center items-center text-lg text-white py-2 px-2 border-b-4 border-[#0e4b66] bg-[#156082]  rounded-lg ">
          VIEW LEADERBOARD
        </a>
      </div> */}



      {/* <div className="flex mt-4 justify-between w-full">
        <a
          href="/"
          className="font-bold cursor-pointer w-full flex justify-center items-center text-lg text-white py-2 px-2 border-b-4 border-red-700 bg-red-500 rounded-lg ">
          BACK
        </a>
      </div> */}
    </div>
  );
};

export default CardFinish;
